import React from 'react';
import SelectInput from '@havenengineering/module-shared-library/dist/form/components/SelectInput';
import styles from './AccountSelector.module.scss';
import { useAuthContext } from '../../contexts';
import { setActiveAccountCookie } from '../../utils';
export const AccountSelector = ({ activeAccountCookieDomain, className = '', }) => {
    const { loggedInUser, activeAccountId, setActiveAccountId } = useAuthContext();
    if (!loggedInUser || (loggedInUser && loggedInUser.accounts.length < 2)) {
        return null;
    }
    const options = loggedInUser.accounts.map((account) => ({
        label: `${account.areaName} - ${account.pitchNumber}`,
        value: account.accountID.toString(),
    }));
    const handleChange = (accountId) => {
        setActiveAccountId(accountId);
        setActiveAccountCookie(accountId, activeAccountCookieDomain);
    };
    return (<div className={className}>
      <SelectInput className={styles.accountSelector} id='activeAccount' label='Selected holiday home' options={options} value={(activeAccountId === null || activeAccountId === void 0 ? void 0 : activeAccountId.toString()) || ''} disabled={false} onChange={(selected) => handleChange(+selected)}/>
    </div>);
};
